import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SFGridContainer, SFGridItem } from "../grid";
import SFContainer from "../container";
import SFButton from "../button";
import {
  SFArrowBackIcon,
  SFArrowForwardIcon,
  SFMoreVerticalIcon,
} from "../icons";
import SFIconButton from "../button/iconButton";
import { stepperActions } from "../../redux/reducers/stepperReducer";
import StepActions from "../../constants/stepActions";
import getStyled from "../../hooks/getStyled";
import SFDropdown from "../dropdown";

const { styled } = getStyled();

const StyledActionsContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  height: 56,
  display: "flex",
  alignItems: "center",
  width: "100%",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  ".menuOpen & ": {
    paddingLeft: 252,
  },
  ".menuClosed & ": {
    paddingLeft: 65,
  },
}));

const StepperActionBtns = ({
  stepsLength,
  stepperName,
  actions,
  placement,
}) => {
  const [dropdownState, setDropdownState] = useState({
    open: false,
    anchorEl: null,
  });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const stepperReduxState = useSelector((state) => {
    return state.stepper.find((stepper) => stepper.name === stepperName);
  });

  const nextBackHandler = (action) => {
    dispatch(
      stepperActions.triggerStepChange({
        stepAction: action,
        name: stepperName,
      })
    );
  };

  const toggleHandler = (e) => {
    setDropdownState((curState) => ({
      ...curState,
      open: !curState.open,
      anchorEl: e.currentTarget,
    }));
  };

  const closeHandler = () => {
    setDropdownState((curState) => ({
      ...curState,
      open: false,
    }));
  };

  if (!stepperReduxState) {
    return null;
  }

  return (
    <StyledActionsContainer>
      <div style={{ width: "100%", maxWidth: 1607, margin: "0 auto" }}>
        <SFContainer>
          <SFGridContainer justifyContent="flex-end">
            <SFGridItem xs="auto">
              <SFDropdown
                open={dropdownState.open}
                anchorEl={dropdownState.anchorEl}
                onClose={closeHandler}
                placement={placement}
                trigger={
                  <SFIconButton variant="secondary" onClick={toggleHandler}>
                    <SFMoreVerticalIcon />
                  </SFIconButton>
                }
                items={actions}
              />
            </SFGridItem>
            <SFGridItem xs="auto">
              <SFButton
                disabled={stepperReduxState.activeStep === 0}
                variant="secondary"
                onClick={nextBackHandler.bind(this, StepActions.BACK)}
                icon={<SFArrowBackIcon />}
              >
                {t("components.stepper.actions.back")}
              </SFButton>
            </SFGridItem>
            <SFGridItem xs="auto">
              <SFButton
                variant="primary"
                onClick={nextBackHandler.bind(this, StepActions.NEXT)}
                endIcon={stepperReduxState.activeStep < stepsLength - 1 && (
                  <SFArrowForwardIcon />
                )}
              >
                {stepperReduxState.activeStep === stepsLength - 1
                  ? t("components.stepper.actions.finish")
                  : t("components.stepper.actions.next")}
                
              </SFButton>
            </SFGridItem>
          </SFGridContainer>
        </SFContainer>
      </div>
    </StyledActionsContainer>
  );
};

StepperActionBtns.defaultProps = {
  placement: "top",
};
StepperActionBtns.propTypes = {
  stepsLength: PropTypes.number.isRequired,
  stepperName: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      function: PropTypes.func,
      icon: PropTypes.node,
    })
  ),
  /*Tooltip placement.*/
  placement: PropTypes.oneOf([
    "bottom-end",
    "bottom-start",
    "bottom",
    "left-end",
    "left-start",
    "left",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top",
    "bottom",
  ]),
};

export default StepperActionBtns;
